/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type LabelDropdownJS_labels = ReadonlyArray<{
    readonly color: string | null;
    readonly name: string | null;
    readonly id: string;
    readonly category: {
        readonly id: string;
        readonly name: string | null;
    } | null;
    readonly " $refType": "LabelDropdownJS_labels";
}>;
export type LabelDropdownJS_labels$data = LabelDropdownJS_labels;
export type LabelDropdownJS_labels$key = ReadonlyArray<{
    readonly " $data"?: LabelDropdownJS_labels$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"LabelDropdownJS_labels">;
}>;



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "LabelDropdownJS_labels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Label"
};
})();
(node as any).hash = '0edf1d963115d6c46df6b56864fcb549';
export default node;
